import { render, staticRenderFns } from "./ReferenceContract.vue?vue&type=template&id=b5d05302&scoped=true"
import script from "./ReferenceContract.vue?vue&type=script&lang=js"
export * from "./ReferenceContract.vue?vue&type=script&lang=js"
import style0 from "./ReferenceContract.vue?vue&type=style&index=0&id=b5d05302&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d05302",
  null
  
)

export default component.exports